import axios from 'axios';
import store from '../store';
import { UserMgmt } from '../models/UserMgmt';
import { ActiveFor } from '../utils/UserExpiry';
import {
  reactivateBody,
  userActionPath,
  userUpsertPayload,
} from '../utils/UserMgmtApi';

export interface PhoneValidationResult {
  isValid: boolean;
  isoRegionCode: string | null;
  phoneE164: string | null;
  message: string | null;
}

export interface CountryRegion {
  isoRegionCode: string;
  description: string;
}

const apiClient = axios.create({
  baseURL: process.env.VUE_APP_API_ROOT,
  withCredentials: false, // This is the default
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

let token = '';

export default {
  getUsers() {
    token = store.getters.token;
    return apiClient.get('/user', {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  /** EN-1883: activeFor only when the admin picked a period. */
  postUser(user: UserMgmt, activeFor?: ActiveFor) {
    token = store.getters.token;
    return apiClient.post('/user', userUpsertPayload(user, activeFor), {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  validatePhone(isoRegionCode: string | null, phone: string | null) {
    token = store.getters.token;
    return apiClient.post<PhoneValidationResult>(
      '/user/phone-validation',
      { isoRegionCode, phone },
      { headers: { Authorization: `Bearer ${token}` } }
    );
  },
  getCountryRegions() {
    token = store.getters.token;
    return apiClient.get<CountryRegion[]>('/user/country-regions', {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  deleteUser(userId: string) {
    token = store.getters.token;
    return apiClient.delete('/user/' + userId, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  regenerateTemporaryPassword(userId: string) {
    token = store.getters.token;
    return apiClient.post('/user/' + userId + '/temporary-password', null, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  // EN-1883: deactivate / reactivate / extend; each returns the updated user.
  deactivate(userId: string) {
    token = store.getters.token;
    return apiClient.post(
      userActionPath('/user', userId, 'deactivate'),
      undefined,
      { headers: { Authorization: `Bearer ${token}` } }
    );
  },
  reactivate(userId: string, activeFor?: ActiveFor) {
    token = store.getters.token;
    return apiClient.post(
      userActionPath('/user', userId, 'reactivate'),
      reactivateBody(activeFor),
      { headers: { Authorization: `Bearer ${token}` } }
    );
  },
  extend(userId: string, activeFor: ActiveFor) {
    token = store.getters.token;
    return apiClient.post(
      userActionPath('/user', userId, 'extend'),
      { activeFor },
      { headers: { Authorization: `Bearer ${token}` } }
    );
  },
};
